import { IconProps } from './AllIcons';

/** Solid triangle for a "play" control; pairs with {@link PauseGlyph}. */
export const PlayGlyph = ({ color = 'currentColor', size = 10, ...props }: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 10 10' fill='none' aria-hidden={'true'} {...props}>
    <path d='M1.5 0l7.5 5-7.5 5z' fill={color} />
  </svg>
);

/** Two solid bars for a "pause" control; pairs with {@link PlayGlyph}. */
export const PauseGlyph = ({ color = 'currentColor', size = 10, ...props }: IconProps) => (
  <svg width={size} height={size} viewBox='0 0 10 10' fill='none' aria-hidden={'true'} {...props}>
    <path d='M1 0h3v10H1zM6 0h3v10H6z' fill={color} />
  </svg>
);
